<template>
  <div id="userLayout" class="user-layout-wrapper">
    <div class="container">
      <a-row style="height:100%">
        <a-col :span="12" :offset="12"  style="display: flex;height:100%">
          <div style="align-self: center;width: 100%">
            <div class="main">
              <div class="desc">
                <span class="en-title">{{$t('layouts.appShortName')}}</span>
              </div>
              <div class="header">
                <a href="/">
                  <!-- <img src="~@/assets/logo.png" class="logo" alt="logo"> -->
                  <span class="title">{{$t('layouts.appName')}}</span>
                </a>
              </div>
              <div class="form-warp">
                <router-view></router-view>
              </div>
            </div>
            <div class="footer">
              <div class="links">
                <!-- <a href="_self">帮助</a>
                <a href="_self">隐私</a>
                <a href="_self">条款</a> -->
              </div>
              <!-- <div class="copyright">
                <span>{{$t('layouts.company')}} Copyright &copy; 2019 - {{new Date().getFullYear()}} </span>
                <span><a style="color:rgba(255, 255, 255, 0.6)" href="http://beian.miit.gov.cn" target="_blank">{{$t('layouts.ICP')}}</a></span>
              </div> -->
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import RouteView from './RouteView'
// import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: {},
  mixins: [],
  data () {
    return {}
  },
  computed: {
    ...mapState(['lang'])
  },
  mounted () {
    document.body.classList.add('userLayout')
    if (this.lang === 'zh_CN') {
      document.title = '智能门禁系统'
    }
    if (this.lang === 'en_US') {
      document.title = 'Intelligent ACS'
    }
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
  @font-face {
    font-family: '华文琥珀';
    src: url('../assets/fonts/hwhp.ttf');
    font-weight: normal;
    font-style: normal;
  }
  .en-title {
    font-family: '华文琥珀' ;
  }
  #userLayout.user-layout-wrapper {
    height: 100%;
    background-image: url('../assets/login/login_page_bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    min-width: 1366px;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      height: 100%;

      a {
        text-decoration: none;
      }

      .main{
        width: 520px;
        margin: 0 auto;

        .header {
          height: 44px;
          line-height: 44px;
          padding-left: 20px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: white;
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            position: relative;
            top: 2px;
            letter-spacing: 5px;
            margin-bottom: 12px;
          }
        }
        .desc {
          font-size: 33px;
          color: white;
          padding-left: 20px;
          background: linear-gradient(to right, #00B5FA, #0076A8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .form-warp{
          background-image: url('../assets/login/login_bg.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }

      .footer {
        // position: absolute;
        width: 100%;
        // bottom: 0;
        // padding: 0 16px;
        // margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(255, 255, 255, 1);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: white;
          font-size: 14px;
        }
      }
    }
  }
</style>
